import React, {useState} from 'react';
import {connect} from "react-redux";
import classnames from 'classnames';
import {setActiveGuestAction, setActiveStepAction, startGuestProgress} from "~/redux/actions/guests";
import {TickIcon} from "~/Components/Icons/Icons";
import Loader from "react-loader";
import TextTranslate from '../../../Components/TextTranslate/TextTranslate';


const GuestCard = ({guest, activeGuest, activeStep, steps, index, ...props}) => {
    
    const [loading, setLoading] = useState(false);

    const active = activeGuest === index;

    const classes = {
        'card': true,
        'shadow-sm': true,
        'bg-white': true,
        'cursor-pointer': true,
        'active': active
    }

    const handleCardClick = () => {

        if (!guest.started) {

            setLoading(true);

            props.dispatch(startGuestProgress(guest.id)).then(() => {
                props.dispatch(setActiveGuestAction(index));
            }).finally(() => setLoading(false));

            return;
        }

        props.dispatch(setActiveGuestAction(index));
    };

    const handleStepChange = (step) => {
        props.dispatch(setActiveStepAction(step));
    };
    

    return (
        <div className={classnames(classes)} onClick={handleCardClick}>
            <div className="card-body">

                <Loader loaded={!loading} loadedClassName="row">
                    <div className="col-6 text-type-caption">
                        {guest.main ?
                            <TextTranslate name="reg-main-guest" fallback="Main Guest"/> :
                            <><TextTranslate name="reg-guest-number" fallback="Guest #"/> {index}</>
                        }
                    </div>
                    <div className="col-6 text-caption text-primary text-right font-weight-500">
                        {guest.started && (
                            <span>{guest.progress.complete}/{guest.progress.total} <TextTranslate name="word-complete" fallback="Complete"/></span>
                        )}

                        {!guest.started && (
                            <span><TextTranslate name="reg-click-to-start" fallback="Click to start"/></span>
                        )}
                    </div>
                </Loader>

                {
                    guest.first_name || guest.last_name ?
                    <div className="row">
                        <div className="col-12">
                            <div className="card-title text-body text-body-size font-weight-500 mb-3">{guest.first_name} {guest.last_name}</div>
                        </div>
                    </div> : null
                }

                {guest.started && active && (
                    <div className="row">
                        <div className="col-12">
                            <ul className="list-unstyled mb-3">
                                {Object.keys(steps).map((step) => {
                                    return (
                                        <li key={step}>
                                            <TickIcon
                                                primary={guest.progress.steps[step]}
                                                className="mr-2 d-inline" />
                                            <a onClick={() => handleStepChange(step)}>{steps[step]?.label}</a>
                                        </li>
                                    );
                                })}
                            </ul>
                            {guest && !guest.main && guest.started &&
                                <button
                                    className="d-lg-none d-block btn btn-sm btn-danger text-uppercase mb-1 w-100"
                                    onClick={() => props.confirmGuestDelete(true)}
                                >
                                    <TextTranslate name="reg-delete-guest" fallback="Delete guest"/>
                                </button>
                            }
                            <button
                                className="d-lg-none d-block btn btn-sm btn-primary text-uppercase w-100"
                                onClick={() => props.focusOnForm()}
                            >
                                <TextTranslate name="reg-continue-form"  fallback="Continue Form"/>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    activeGuest: state.guests?.activeGuest,
    activeStep: state.guests?.activeStep[state.guests?.activeGuest],
    steps: state.guests?.steps,
});

export default connect(mapStateToProps)(GuestCard);
